import {
  RESET_FORGET_PASSWORD,
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  SET_NEW_PASSWORD,
  SET_NEW_PASSWORD_SUCCESS,
} from "./actionTypes";

export const resetForgetPassword = () => {
  return {
    type: RESET_FORGET_PASSWORD,
    payload: {},
  };
};

export const userForgetPassword = (user, history) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, history },
  };
};

export const userForgetPasswordSuccess = (data) => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: data,
  };
};

export const setNewPsw = (user, history, pswToken) => {
  return {
    type: SET_NEW_PASSWORD,
    payload: { user, history, pswToken },
  };
};

export const setNewPswSuccess = (data) => {
  return {
    type: SET_NEW_PASSWORD_SUCCESS,
    payload: data,
  };
};
export const apiError = (error) => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: error,
  };
};
